import React from "react";
import  { useState, useEffect } from 'react';
import './classes/SportsEducationProgram.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const SteveWisensalephdTestimonial = () => {

    const app_url = configData.APP_URL;
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        Promise.all([
         
        ])
        .then(() => {
     
        setIsLoading(false);
        })
    },[]);

    const doBackAway = () => {
        if (window.history.length > 1) {
            navigate(-1); // Go back
        } else {
            navigate('/'); // Fallback to home
        }
    };
    

    return (
        <>
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main" style={{minHeight: "400px"}} className="steve-wisensale-testimonial-main">
                <Helmet><title>Steve Wisensale, Ph.D.</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div style={{float: "left"}}>
                        <img src="/basic/web/images/scout/picture-1938-1442595001.jpg" alt="Steve Wisensale, Ph.D." style={{"width":"100px"}} />
                    </div>
                    <div style={{float:"left", paddingLeft:"2%", paddingTop:"2%"}}><strong>Steve Wisensale, Ph.D.</strong></div>
                    <div style={{textAlign: "right"}}><a href onClick={doBackAway} style={{cursor: "pointer"}}>« Back</a></div>
                    <div style={{clear:"both"}}></div>
                    <div style={{marginBottom: "8px"}}>
                        <p style={{marginTop: "0px"}}>
                            As I near retirement I am attempting to make a smooth transition into baseball - either in management or scouting of some sort. The SMWW course on "Baseball GM and Scouting" was my first step toward converting stumbling blocks into stepping stones as I make a career transition.
                        </p>
                    </div>
                </div>
                <div className="right">
                       {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default SteveWisensalephdTestimonial;